// get environment variables
// process.env is a special object so we can't use destructuring
const GATSBY_BASE_URL = process.env.GATSBY_BASE_URL
const GATSBY_USE_HTTP = process.env.GATSBY_USE_HTTP
const GATSBY_DONT_USE_WWW = process.env.GATSBY_DONT_USE_WWW
const GATSBY_API_URL = process.env.GATSBY_API_URL
const GATSBY_DEFAULT_SUBDOMAIN = process.env.GATSBY_DEFAULT_SUBDOMAIN

const https = !GATSBY_USE_HTTP
const www = !GATSBY_DONT_USE_WWW
const baseUrl = GATSBY_BASE_URL
const defaultSubdomain = GATSBY_DEFAULT_SUBDOMAIN || 'www'

const makeUrl = (path, subdomain = www ? defaultSubdomain : '') =>
  `http${https ? 's' : ''}://${subdomain}${
    subdomain ? '.' : ''
  }${baseUrl}${path}`

export const apiUrl = GATSBY_API_URL || makeUrl('', 'lumberjack')
export const airbnbReferalUrl = makeUrl('/r/')
// TODO: remove hardcode
export const airbnbShareUrl =
  __BUILDFOR__ === ' '
    ? makeUrl('/airbnb/form')
    : 'https://massaschadeconsument.nl/collectieve-acties/airbnb'
export const airbnbYoutubeUrl = 'https://www.youtube.com/watch?v=pOH9o-HxqfM'
export const googleReviewLink =
  __BUILDFOR__ === ' ' &&
  'https://www.google.nl/search?authuser=1&hl=nl&q= &ludocid=3898737138780680916&lsig=AB86z5WyT85ZEhFIyTg0XJ6Qnpde#lrd=0x47c5e12b393c9635:0x361b18c575a532d4,1,,,@'
export const contactEmail =
  __BUILDFOR__ === ' '
    ? 'info@ .nl'
    : 'deelname@massaschadeconsument.nl'
